import React, { useState, useEffect } from 'react';
import { Form, Button, Row, Col, Alert, Modal } from 'react-bootstrap';
import Navbar from '../../dashboard/navbar';
import Sidebar from '../../dashboard/sidebar';
import { useLocation, Link, useNavigate } from 'react-router-dom';
import useAuth from '../../dashboard/useAuth';
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
import { FaArrowAltCircleRight, FaArrowCircleLeft, FaArrowLeft, FaArrowRight, FaMoneyBill, FaShoppingCart, FaUser, FaTrash } from 'react-icons/fa';
import { useKKiaPay } from 'kkiapay-react';


const Paiement_reussi = ({ titre }) => {
    useAuth();
    const user_id = localStorage.getItem('user_id');
    const [alert, setAlert] = useState({ message: '', type: '' });


    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
        setTimeout(() => {
            setAlert({ message: '', type: '' });
        }, 7000);
    };

    ///////////////////////////////////////////////////////////// panier////////////////////////////////////////////

    const [panier, setPanier] = useState([localStorage.getItem('panier')]);
    console.log('panier : ', panier);


    ///////////////////////////////////////////////////////////// panier////////////////////////////////////////////

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} titre={titre} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className='d-flex align-items-center'><FaMoneyBill size={25} className='mr-2' />Mes abonnements</h2>
                            <small>Ici vous pouvez consulter ou modifier vos abonnements.</small>

                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        {/* Utiliser Link de react-router-dom pour la navigation */}
                                        <Link to={`/Abonnements`}>Mes abonnements</Link>
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>
                    <div className="container mt-4">
                        <div className="row">
                            <div className="col-lg-8">
                                {alert.message && (
                                    <div className={`alert alert-${alert.type}`}>
                                        {alert.message}
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="col-lg-12">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Paiement_reussi;
